import {
  SlResizeObserver
} from "./chunk.U7QLU357.js";

// src/components/resize-observer/resize-observer.ts
var resize_observer_default = SlResizeObserver;
SlResizeObserver.define("sl-resize-observer");

export {
  resize_observer_default
};
